import Flicking from "@egjs/flicking";
import "@egjs/flicking/dist/flicking.css";

export default class Gallery {
    constructor(gallery) {        
        const flicking = new Flicking(gallery, {
            panelsPerView: 2,
            align: "prev"
        });
    }
}
